import { render } from "./ResponsibilitiesSection.vue?vue&type=template&id=23c04ade"
import script from "./ResponsibilitiesSection.vue?vue&type=script&lang=js"
export * from "./ResponsibilitiesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__